// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bl4y","toggleWrap":"styles_toggleWrap__2bes1","content":"styles_content__3Gj5-","selectAreaCode":"styles_selectAreaCode__33fQs"};